import { render, staticRenderFns } from "./CaliperDetailsDistanceComponent.vue?vue&type=template&id=03506234&scoped=true"
import script from "./CaliperDetailsDistanceComponent.js?vue&type=script&lang=js&external"
export * from "./CaliperDetailsDistanceComponent.js?vue&type=script&lang=js&external"
import style0 from "./CaliperDetailsDistanceComponent.vue?vue&type=style&index=0&id=03506234&prod&lang=scss&scoped=true"
import style1 from "./CaliperDetailsDistanceComponent.vue?vue&type=style&index=1&id=03506234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03506234",
  null
  
)

export default component.exports